// Copyright (c) 2017 Deere & Company

import AdvancedClaimSummaryReport from '../../../reports/advanced-claim-summary/state-connector';

export default {
    component: AdvancedClaimSummaryReport,
    name: 'ADVANCED_CLAIM_SUMMARY',
    path: 'advanced-claim-summary'
};



// WEBPACK FOOTER //
// ./src/routes/claims/reports/advanced-claim-summary.js